import { useState, useEffect } from 'react';
import api from 'axios';
import { GlobalSettings } from '../types/inventory';

interface UseSettingsReturn {
  settings: GlobalSettings;
  isLoading: boolean;
}

export const useSettings = (): UseSettingsReturn => {
  const [settings, setSettings] = useState<GlobalSettings>({
    leadTime: 7,
    diasCoberturaAlvo: 21,
    excludeNoSalesNoStock: false,
    excludeNoSalesWithStock: false,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchSettings = async () => {
      try {
        const response = await api.get<{
          success: boolean;
          data: { lead_time: number; cobertura_alvo: number; exclude_no_sales_no_stock: boolean; exclude_no_sales_with_stock: boolean };
        }>('/sellers/stock-intelligence/settings');

        if (!cancelled && response.data.success) {
          setSettings({
            leadTime: response.data.data.lead_time,
            diasCoberturaAlvo: response.data.data.cobertura_alvo,
            excludeNoSalesNoStock: Boolean(response.data.data.exclude_no_sales_no_stock),
            excludeNoSalesWithStock: Boolean(response.data.data.exclude_no_sales_with_stock),
          });
        }
      } catch {
        // keep defaults
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    fetchSettings();

    return () => {
      cancelled = true;
    };
  }, []);

  return { settings, isLoading };
};
